export default "__VITE_ASSET__30ca51ec__"